'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:account:getUser');
}

var _invoke = require('../invoke');

/**
 * 获取用户登录信息
 *
 * 用户已登录时 resolve，用户未登录 reject
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof account
 * @static
 * @name getUser
 * @return {Promise<user | err>}
 * @example
 *  hbnb.account.getUser()
 *      .then(function(user) {
 *          user = {
 *              userId: 1234567,
 *              userName: 'name is string',
 *              userToken: 'token is string'
 *          }
 *      })
 *      .catch(function(err) {
 *          err = {
 *              message: "用户未登录美团",
 *              status: -1
 *          }
 *      });
 */

module.exports = function(cb, eb) {
    var p = new Promise(function(resolve, reject) {
        _invoke('user', 'get_user', {
            callback: function(user) {
                if (process.env.NODE_ENV !== 'production') {
                    debug('user is %j', user, user);
                }
                resolve(user);
            },
            errback: reject
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/account/get-user.js
// module id = 566
// module chunks = 0